import { render, staticRenderFns } from "./AttachedDocument.vue?vue&type=template&id=337a15ae&"
import script from "./AttachedDocument.vue?vue&type=script&lang=js&"
export * from "./AttachedDocument.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports